import React, { useEffect, useRef } from "react";
import { ArrowUpIcon } from "@heroicons/react/24/solid"; // Heroicons ikonu import ediyorum
import backgroundSvg from "./graph_background.svg";
import Chart from "react-apexcharts";

const BubbleChart = ({ themeMode, data }) => {
    const chartRef = useRef(null);
    console.log("bubble chart", data)
    useEffect(() => {
        if (chartRef.current) {
            const grid = chartRef.current.querySelector(".apexcharts-grid");
            if (grid) {
                grid.classList.add("my-custom-grid-class");
            }
        }
    }, []);

    const options = {
        chart: {
            type: "scatter",
            height: 350,
            zoom: {
                enabled: false
            },
            background: "transparent", //`url(${backgroundSvg}) no-repeat center center / contain`,
            events: {
                dataPointSelection: function (event, chartContext, config) {
                    event.stopPropagation(); // Tıklama olayını durdur
                    event.preventDefault();  // Varsayılan davranışı iptal et
                },
                mounted: function (chartContext) {
                    setTimeout(() => {
                        if (chartRef.current) {
                        addBackgroundToGrid(chartContext);
                        }
                    }, 3000);
                },
                updated: function (chartContext) {
                    setTimeout(() => {
                        if (chartRef.current) {
                            addBackgroundToGrid(chartContext);
                            }
                    }, 3000);
                }
            },
        },
        markers: {
            size: 10, // Bubble boyutu
            shape: "square", // Shape ayarı
            strokeWidth: 2,
            strokeColors: "#D3D3D3", // Border rengi
            fillColors: ["#FFFFFF"], // Bubble iç rengi
            // Etiket ekleme
            label: function (seriesIndex, dataPointIndex, w) {
                const dataLength = w.config.series[seriesIndex].data.length; // Data array'inin uzunluğunu alıyoruz
                console.log("data", dataLength)
                return `r${dataPointIndex + 1} / ${dataLength}`; // Örneğin "r1 / 3", "r2 / 3"
            }
        },
        fill: {
            colors: ["transparent"], // Alternatif renk ayarı
        },
        grid: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            },
        },
        toolbar: {
            show: false,
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "12px",
                fontWeight: "bold",
                colors: ["#000"],
            },
            formatter: function (val, { dataPointIndex }) {
                return `R${dataPointIndex + 1}`; // **R1, R2, R3, ... şeklinde yazdır**
            },
        },
        tooltip: {
            custom: function ({ seriesIndex, dataPointIndex, w }) {
                const recommendation = data[dataPointIndex].recommendation; // İlgili index'teki recommendation'ı al
                return `<div class="custom-tooltip">
                  <strong>Recommendation:</strong> ${recommendation}
                </div>`;
            }
        },
        markers: {
            size: 10, // Kare boyutu
            shape: "square", // ApexCharts içinde "square" desteklenmez, CSS ile düzelteceğiz
            strokeWidth: 2,
            strokeColors: "transparent", // Siyah kenarlık
        },
        xaxis: {
            min: -1,  // X ekseni 0'dan başlasın
            max: 102, // X ekseni 100'e kadar gitsin
            tickAmount: 1,
            title: {
                text: "EASE OF IMPLEMANTATIONS", // Y ekseninin başlığını 'Growth' olarak ayarladım
                offsetY: -30,
                style: {
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themeMode === "dark" ? "#fff" : "#000",
                    background: "transparent",
                },
            },
            labels: {
                style: {
                    colors: themeMode === "dark" ? "#fff" : "#000",
                    background: "transparent",
                },
                offsetX: -10,
                formatter: function (value) {
                    // Etiketleri manuel olarak belirle
                    // if (value === 0) return "Low";
                    // if (value === 50) return "Medium";
                    // if (value === 100) return "High";
                    return "";
                },
            },
            // crosshairs: {
            //     show: true,
            //     width: 1,
            //     position: 'back',
            //     stroke: {
            //         color: themeMode === "dark" ? "#fff" : "#000",
            //         width: 1,
            //         dashArray: 3,
            //     },
            // },
        },
        yaxis: {
            tickAmount: 1,
            min: 0,
            max: 102,
            lines: {
                show: true,
            },
            title: {
                text: "BENEFIT", // Y ekseninin başlığını 'Growth' olarak ayarladım
                style: {
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themeMode === "dark" ? "#fff" : "#000",
                },
                offsetX: -9,
            },
            labels: {
                style: {
                    colors: themeMode === "dark" ? "#fff" : "#000",

                },
                formatter: function (value) {
                    // Y eksenindeki değerleri "Low", "Medium", "High" olarak dönüştür
                    // if (value > 0 && value <= 33) {
                    //   return "Low";
                    // } else if (value > 33 && value <= 66) {
                    //   return "Medium";
                    // } else if (value > 66) {
                    //   return "High";
                    // }
                    // return value;
                    return "";
                },
            },
            // crosshairs: {
            //     show: true,
            //     width: 1,
            //     position: 'back',
            //     stroke: {
            //         color: themeMode === "dark" ? "#fff" : "#000",
            //         width: 1,
            //         dashArray: 3,
            //     },
            // },
        },
        annotations: {
            position: 'back',
            points: [
                {
                    x: 15,
                    y: 98,
                    marker: {
                        size: 0
                    },
                    label: {
                        text: "Long Term Initiatives",
                        style: {
                            color: themeMode === "dark" ? "#fff" : "#000",
                            background: themeMode === "dark" ? "#000" : "#fff",
                        }
                    }
                },
                {
                    x: 50,
                    y: 98,
                    marker: {
                        size: 0
                    },
                    label: {
                        text: "Critical Enablers",
                        style: {
                            color: themeMode === "dark" ? "#fff" : "#000",
                            background: themeMode === "dark" ? "#000" : "#fff",
                        }
                    }
                },
                {
                    x: 84,
                    y: 98,
                    marker: {
                        size: 0
                    },
                    label: {
                        text: "Quick Wins",
                        style: {
                            color: themeMode === "dark" ? "#fff" : "#000",
                            background: themeMode === "dark" ? "#000" : "#fff",
                        }
                    }
                },
                {
                    x: 15,
                    y: 0,
                    marker: {
                        size: 0
                    },
                    label: {
                        text: "De-prioritize",
                        style: {
                            color: themeMode === "dark" ? "#fff" : "#000",
                            background: themeMode === "dark" ? "#000" : "#fff",
                        }
                    }
                }
            ]
        }
    };

    function addBackgroundToGrid(chartContext) {
        const svg = chartContext.el.querySelector("svg");
        const grid = svg.querySelector(".apexcharts-grid");
        if (!svg) {
            console.warn("SVG bulunamadı, fonksiyon tekrar denenebilir.");
            return; // Eğer SVG yoksa fonksiyonu durdur
        }
        if (!grid) {
            console.warn("Grid bulunamadı, fonksiyon tekrar denenebilir.");
            return;
        }
    
        if (svg && grid) {
            const existingPattern = svg.querySelector("#gridPattern");
            if (!existingPattern) {
                // 🎯 Pattern tanımla
                const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
                const pattern = document.createElementNS("http://www.w3.org/2000/svg", "pattern");

                pattern.setAttribute("id", "gridPattern");
                pattern.setAttribute("patternUnits", "userSpaceOnUse"); // 📏 Tam alanı kapla
                pattern.setAttribute("width", grid.getBBox().width);
                pattern.setAttribute("height", grid.getBBox().height);

                const image = document.createElementNS("http://www.w3.org/2000/svg", "image");
                image.setAttribute("href", backgroundSvg);
                image.setAttribute("width", grid.getBBox().width);
                image.setAttribute("height", grid.getBBox().height);
                image.setAttribute("preserveAspectRatio", "none"); // 🏹 Tam olarak yay

                pattern.appendChild(image);
                defs.appendChild(pattern);
                svg.prepend(defs);
            }

            const existingRect = svg.querySelector(".custom-grid-bg");
            if (!existingRect) {
                const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                rect.setAttribute("x", grid.getBBox().x); // Grid'in sol başlangıcı
                rect.setAttribute("y", grid.getBBox().y); // Grid'in üst başlangıcı
                rect.setAttribute("width", grid.getBBox().width); // Grid genişliği kadar
                rect.setAttribute("height", grid.getBBox().height); // Grid yüksekliği kadar
                rect.setAttribute("fill", "url(#gridPattern)"); // 🎯 Pattern uygula
                rect.classList.add("custom-grid-bg");

                grid.prepend(rect); // **Grid'in en altına ekle**
            }
        }
    }

    const series = [
        {
            name: "Square Bubbles",
            // data: data?.map((item, index) => index == 0 ? [77,76] : [item.ease_of_implementation, item.benefit])
            data: data?.map((item) => [item.ease_of_implementation, item.benefit])
           
        }
    ];

    return (
        <div ref={chartRef} className="w-[850px] mt-7">
            <style>
                {`
                  .apexcharts-marker {
                    border-radius: 0 !important; /* Kare olması için köşe yuvarlaklığı kaldırılıyor */
                    width:30px!important;
                    height:20px!important;
                    border:1px solid lightgray !important
                  }
                `}
            </style>
            <Chart options={options} series={series} type="scatter" height={650} />
        </div>
    );
};
export default BubbleChart;
